import { render, staticRenderFns } from "./registar_abastecimento.vue?vue&type=template&id=35e848d6&scoped=true"
import script from "./registar_abastecimento.vue?vue&type=script&lang=js"
export * from "./registar_abastecimento.vue?vue&type=script&lang=js"
import style0 from "./registar_abastecimento.vue?vue&type=style&index=0&id=35e848d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e848d6",
  null
  
)

export default component.exports